import React, { Component } from 'react';

class ServicesCommunity extends Component {
    
    render() {
      return (
        <React.Fragment>
            <p id="title">Community Management Services</p>

            <ul>
                
                <li>
                    Communication with residents
                </li>
                <li>
                    Development of compound governing rules and implementation of the same
                </li>
                <li>
                    Handling of daily maintenance calls and other requests from residents
                </li>
                <li>
                    Handling of property handover to buyers and follow up on snag list rectification by developer as per the defined time frame
                </li>
                <li>
                    Invoicing and follow up on outstanding dues
                </li>
                <li>
                    Creation and maintenance of owner’s registry
                </li>
                <li>
                    File keeping for all individual properties
                </li>
                <li>
                    Communication with owner’s association and implementation of decisions 
                </li>
                <li>
                    Sinking funds collection and utilization (procedures are already developed by us)
                </li>
                <li>
                    Consultancy on residence management and owner’s management
                </li>
                <li>
                    Issuing of monthly operational report 
                </li>
                <li>
                    Hiring of external auditors for auditing of annual residence budget and issuing of auditing report
                </li>
                <li>
                    Conducting of quarterly owner’s satisfaction survey
                </li>
            </ul>

        </React.Fragment>
      );
   }
}

export default ServicesCommunity;